// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentMap_wrapper__qPhtq","marker":"ApartmentMap_marker__FQaSL"};